import { render, staticRenderFns } from "./TwoFactorSettings.vue?vue&type=template&id=08d5a89a&scoped=true"
import script from "./TwoFactorSettings.vue?vue&type=script&lang=js"
export * from "./TwoFactorSettings.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorSettings.vue?vue&type=style&index=0&id=08d5a89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5a89a",
  null
  
)

export default component.exports